<template>
  <!--  <ion-page>
    <ion-content :fullscreen="true">
      <div class="logo-view">
        <IonImg
          src="https://beautysku-mobile-assets.us-southeast-1.linodeobjects.com/Logo.png"
          class="logo-img"
        >
        </IonImg>
      </div>
      <div class="container-login">
        <h2>Mobile Login</h2>
        <ion-item>
          <div class="label-view">
            <ion-label class="label-style" position="stacked">
              Email or Username
            </ion-label>
          </div>
          <ion-input v-model="email" :placeholder="'example@gmail.com'"></ion-input>
        </ion-item>
        <template v-if="v$.email.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.email.$errors"
            :key="idx.toString()"
            style="color: red"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-item style="margin-top: 25px">
          <div class="label-view">
            <ion-label class="label-style" position="stacked"> Password </ion-label>
          </div>
          <div class="input-view">
            <ion-input
              type="password"
              v-model="password"
              :placeholder="'*******'"
            ></ion-input>
            <ion-icon :icon="eyeOffOutline"></ion-icon>
          </div>
        </ion-item>
        <template v-if="v$.password.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.password.$errors"
            :key="idx.toString()"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-item lines="none">
          <ion-checkbox slot="start" v-model="remember"></ion-checkbox>
          <ion-label>Remember me</ion-label>
          <p
            slot="end"
            class="forget-style"
            @click="router.push('/forgot-password/email')"
          >
            Forgot Password?
          </p>
        </ion-item>

        <ion-button
          style="height: 50px"
          class="login-btn"
          @click="login()"
          :disabled="isLoading"
        >
          <ion-label>
            <ion-spinner v-if="isLoading"></ion-spinner>
            LOGIN
          </ion-label>
        </ion-button>
        <p class="or-style" style="padding-bottom: 20px; padding-top: 20px">
          Or login with
        </p>
        <div class="social-view">
          &lt;!&ndash; <a :href="getGoogleUrl(from)" class="google-auth"> &ndash;&gt;
          <ion-button class="social-btn fb-btn">
            <img
              src="https://beautysku-mobile-assets.us-southeast-1.linodeobjects.com/fb.png"
              class="img-btn"
            />
            Facebook
          </ion-button>
          &lt;!&ndash; </a> &ndash;&gt;
          <ion-button class="social-btn gg-btn">
            <img
              src="https://beautysku-mobile-assets.us-southeast-1.linodeobjects.com/gg.png"
              class="img-btn"
            />
            Google
          </ion-button>
        </div>
        <div class="dont-account">
          <span class="text-16-300">Don't have an account?</span>
          <span class="text-16-700" @click="() => router.push('/signup')"> SIGNUP </span>
        </div>
      </div>
    </ion-content>
  </ion-page>-->
  <ion-page class="signIn-wrapper">
    <ion-content :fullscreen="true">
      <div class="logo-view">
        <ion-img
          class="logo-img"
          :src="require('@/assets/images/logo_multismall.png')"
        ></ion-img>
      </div>
      <div class="container-login">
        <ion-item>
          <div class="label-view">
            <ion-icon :icon="mailOutline" slot="start"></ion-icon>
            <ion-label class="label-style" position="stacked">
              Email
            </ion-label>
          </div>
          <ion-input
            v-model="email"
            placeholder="example@gmail.com"
          ></ion-input>
        </ion-item>
        <template v-if="v$.email.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.email.$errors"
            :key="idx.toString()"
            style="color: red"
          >
            {{ error.$message }}
          </span>
        </template>
        <ion-item style="margin-top: 25px">
          <div class="label-view">
            <ion-icon :icon="lockClosedOutline" slot="start"></ion-icon>
            <ion-label class="label-style" position="stacked">
              Password
            </ion-label>
          </div>
          <div class="input-view">
            <ion-input
              :type="passwordType"
              v-model="password"
              :placeholder="'Type your password'"
            ></ion-input>
            <ion-icon
              :icon="passwordIcon"
              @click="changePasswordType"
              color="black"
            ></ion-icon>
          </div>
        </ion-item>
        <template v-if="v$.password.$error">
          <span
            class="error-message"
            v-for="(error, idx) in v$.password.$errors"
            :key="idx.toString()"
          >
            {{ error.$message }}
          </span>
        </template>

        <p
          slot="end"
          class="forget-style"
          @click="router.push('/forgot-password/email')"
        >
          <span> Forgot Password?</span>
        </p>

        <ion-button
          style="height: 50px"
          class="login-btn"
          @click="login()"
          :disabled="isLoading"
        >
          <ion-label>
            <ion-spinner v-if="isLoading"></ion-spinner>
            <ion-text> Login</ion-text>
          </ion-label>
        </ion-button>
        <p
          class="or-style"
          style="padding-bottom: 20px; padding-top: 20px; color: blueviolet"
        >
          Or login with
        </p>
        <ion-button
          style="height: 50px"
          class="google-login-btn"
          @click="googleLogin()"
          :disabled="isLoading"
        >
          <ion-spinner v-if="isLoading"></ion-spinner>
          <ion-icon slot="start" :icon="logoGoogle"></ion-icon>
          Google Login
        </ion-button>
<!--        <ion-button-->
<!--          style="height: 50px"-->
<!--          class="google-login-btn"-->
<!--          @click="fbLogin()"-->
<!--          :disabled="isLoading"-->
<!--        >-->
<!--          <ion-spinner v-if="isLoading"></ion-spinner>-->
<!--          <ion-icon slot="start" :icon="logoFacebook"></ion-icon>-->
<!--          Facebook Login-->
<!--        </ion-button>-->
        <ion-button
          style="height: 50px"
          class="google-login-btn"
          @click="appleLogin()"
          :disabled="isLoading"
        >
          <ion-spinner v-if="isLoading"></ion-spinner>
          <ion-icon slot="start" :icon="logoApple"></ion-icon>
          Apple Login
        </ion-button>

        <div class="dont-account">
          <span class="text-16-300">Don't have an account?</span>
          <a class="text-16-700" @click="() => router.push('/signup')">
            Register
          </a>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts" setup>
import { defineComponent, computed, ref } from "vue";
import {
  IonContent,
  IonItem,
  IonPage,
  IonInput,
  IonLabel,
  IonImg,
  IonIcon,
  IonButton,
  IonSpinner,
  IonText,
  onIonViewWillLeave,
} from "@ionic/vue";
import {
  mailOutline,
  closeCircle,
  lockClosedOutline,
  eyeOffOutline,
  eyeOutline,
  logoGoogle,
  logoApple,
  logoFacebook,
} from "ionicons/icons";
import { useRouter } from "vue-router";
import useValidate from "@vuelidate/core";
import { required, email as emailType, minLength } from "@vuelidate/validators";
// import { useUserStore } from "@/store/modules/user";
import { useUserStore } from "@/store/modules/user";
import { presentToastWithOptions } from "@/utils/functions";

import { TextFieldTypes } from "@ionic/core";
import {
  SignInWithApple,
  SignInWithAppleResponse,
  SignInWithAppleOptions,
} from "@capacitor-community/apple-sign-in";
import {
  FacebookLogin,
  FacebookLoginResponse,
} from "@capacitor-community/facebook-login";

const userStore = useUserStore();
const router = useRouter();
const isLoading = computed(() => userStore.isLoading);
const email = ref("");
const password = ref("");
const remember = ref(false);
const passwordType = ref<TextFieldTypes>("password");
const confirmPasswordType = ref<TextFieldTypes>("password");
const FACEBOOK_PERMISSIONS = ["email", "public_profile"];
const passwordIcon = computed(() =>
  passwordType.value === "password" ? eyeOutline : eyeOffOutline
);
const confirmPasswordIcon = computed(() =>
  confirmPasswordType.value === "password" ? eyeOutline : eyeOffOutline
);
const changePasswordType = () =>
  (passwordType.value =
    passwordType.value === "password" ? "text" : "password");
const changeConfirmPasswordType = () =>
  (confirmPasswordType.value =
    confirmPasswordType.value === "password" ? "text" : "password");

const rules = computed(() => {
  return {
    email: { required, emailType },
    password: { required, minLength: minLength(6) },
  };
});
const v$ = useValidate(rules, { email, password });

onIonViewWillLeave(() => {
  email.value = "";
  password.value = "";
});

const login = async () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    const result = await userStore.axLoginUser(email.value, password.value);
    if (result) router.push("/tabs/home");
    else presentToastWithOptions("Login Failed. Please Try Again.", "danger");
  }
};

// const googleLogin = async() => {
//   console.log("=== google login ===")
//   const res = await userStore.axGoogleLogin();
//   if (res) router.push("/tabs/home");
//   else presentToastWithOptions("Login failed!");
// }
const googleLogin = async () => {
  console.log("=== google login ===");
  const res = await userStore.axGoogleLogin();

  if (res.success) {
    if (res.isNewUser) {
      await router.push("/profile/create/addphoto");
    } else {
      await router.push("/tabs/home");
    }
  } else {
    await presentToastWithOptions("Login failed!");
  }
};

function generateNonce(length = 32) {
  const charset =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let result = "";
  const values = window.crypto.getRandomValues(new Uint32Array(length));
  for (let i = 0; i < length; i++) {
    result += charset[values[i] % charset.length];
  }
  return result;
}

async function sha256(str: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
type AppleLoginResponse = {
  success: boolean;
  isNewUser?: boolean;
};
const appleLogin = async () => {
  const rawNonce = generateNonce();
  const hashedNonce = await sha256(rawNonce);
  let options: SignInWithAppleOptions = {
    clientId: "com.beautysku.signin",
    redirectURI: `${process.env.VUE_APP_SOCIAL_AUTH_DOMAIN}/login`,
    scopes: "email name",
    state: "12345",
    nonce: hashedNonce,
  };
  SignInWithApple.authorize(options)
    .then(async (result: SignInWithAppleResponse) => {
      const { identityToken, authorizationCode, givenName, familyName } =
        result.response;

      if (!identityToken) {
        throw new Error("Missing identityToken from Apple");
      }
      console.log(result);

      // If you used a nonce, replace "nonce" with it
      const res = (await userStore.axAppleLogin(
        identityToken,
        rawNonce,
        givenName,
        familyName
      )) as AppleLoginResponse;
      console.log("Before if result: ", res, res.success);
      if (res.success) {
        console.log("In success", res.isNewUser);
        try {
          if (res.isNewUser) {
            await router.push("/profile/create/addphoto");
            console.log("Should be on addphoto screen now");
          } else {
            await router.push("/tabs/home");
            console.log("Should be on HOME screen now");
          }
        } catch (e) {
          console.error("Routing error:", e);
        }
      }
      console.log("SignInWIthApple");
    })
    .catch((error) => {
      // Handle error
      console.log(error);
    });
};
const fbLogin = async () => {
  await FacebookLogin.initialize({ appId: "1210908203870825" });

  const result = (await FacebookLogin.login({
    permissions: FACEBOOK_PERMISSIONS,
  })) as FacebookLoginResponse;

  if (result.accessToken) {
    const token = result.accessToken.token;
    console.log(`Facebook access token is ${token}`);

    // Pass the token to the store instead of the user
    const res: any = await userStore.axFbLogin(token);

    if (res.success) {
      console.log("Res", res);
      if (res?.isNewUser) {
        console.log("Navigating to /profile/create/addphoto");
        await router.push("/profile/create/addphoto");
      } else {
        await router.push("/tabs/home");
      }
    } else {
      await presentToastWithOptions("Login failed!", "danger");
    }
  } else {
    console.warn("Facebook login failed or was cancelled");
  }
};
</script>
<style scoped lang="scss">
@import "/src/theme/variables/typography";
@import "/src/theme/variables/color";
.signIn-wrapper {
  ion-content {
    --background: radial-gradient(
      163.76% 50.49% at 61.92% 35.69%,
      rgba(225, 121, 203, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    --background: url("../../assets/images/overlay.png");
  }
  ion-label {
    ion-text {
      text-transform: capitalize;
      @include h3;
    }
  }
  ion-icon {
    color: $pink-normal;
  }
  ion-input {
    @include text-16-400;
  }
  ion-button {
    --background: #e383cf;
    height: 58px !important;
  }

  .label-style {
    color: $pink-normal;
    @include text-18-bold;
    margin-left: 8px;
    margin-bottom: 11px !important;
  }

  .forget-style {
    color: $pink-normal;
    text-align: end;
    @include text-16-400;
    margin-top: 8px;
    span {
      border-bottom: 1px solid $pink-normal;
    }
  }

  .container-login {
    padding: 25px 25px 25px 25px;
    width: 100%;
    ion-item {
      border-bottom: 1px solid rgba(34, 34, 34, 0.25);
    }
  }

  .logo-view {
    height: 35%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }

  .logo-img {
    width: 337px;
    margin: auto;
  }

  .dont-account {
    @include text-16-400;
    text-align: center;
    margin: 35px 0 0 0;
    span {
      color: $secondary-black;
    }
    a {
      color: $pink-normal;
      border-bottom: 1px solid $pink-normal;
    }
  }

  .error-message {
    color: red;
    text-align: start;
    align-self: flex-start;
  }

  ion-label {
    font-weight: 400;
    font-size: 18px !important;
  }

  ion-item ion-label {
    --color: #fff !important;
  }

  h2 {
    padding-top: 30px;
    padding-bottom: 30px;
    color: white;
  }

  .google-login-btn {
    width: 100%;
    --background: #fff;
    --color: #e383cf;
  }
}
</style>
